import { ROUTES } from 'constants/routes';

export const APPOINTMENT_ACTION_OPTIONS = {
  detailRoute: ROUTES.PATIENT_APPOINTMENT,
  from: ROUTES.PATIENT_PROFILE,
};
